import React from 'react';
import PinesCupones from './PinesCupones';

function PinesCuponesQA({ usr_id, permission, token }) {
  return <PinesCupones usr_id={usr_id} permission={permission} token={token} isQA />;
}

export default PinesCuponesQA;
